"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildTeamMemberJoinedMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const icons_1 = require("../icons");
const MOCK_TEAM_LINK = "https://www.zeffy.com/en-US/fundraising/my-campaign/team-sunrise";
const buildTeamMemberJoinedMockData = ({ orgName, color, isDarkMode, firstName = "Marie", memberName = "John Smith", teamTitle = "Team Sunrise", teamLink = MOCK_TEAM_LINK, locale = "en", }) => {
    const labels = (0, email_templates_1.getEmailLabels)(locale);
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color || "#FFFFFF", isDarkMode ? "dark" : "light");
    const iconZeffyLogo = theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight;
    return {
        labels,
        theme,
        iconZeffyLogo,
        lang: locale,
        subject: labels.teamMemberJoinedSubject.replace("{memberName}", memberName),
        orgName: orgName || "Bright Futures Foundation",
        firstName,
        memberName,
        teamTitle,
        teamLink,
        message: null,
    };
};
exports.buildTeamMemberJoinedMockData = buildTeamMemberJoinedMockData;
